import React, { useEffect } from 'react';

import ExtractorService from 'common/services/Extractor';

const GooddaysReviewWidget = ({ field, reference }) => {
  const critizrEnable = field ? ExtractorService.extractBoolean(field) : false;

  useEffect(() => {
    if (!critizrEnable || typeof document === 'undefined') return;

    const titleText = 'Goodays feedback widget';

    const setTitles = (root = document) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('iframe.cz-embed').forEach((el) => {
        if (!el.title) el.title = titleText;
      });
    };

    // set existing iframes
    setTitles(document);

    // observe DOM for injected iframes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          try {
            if (node.matches && node.matches('iframe.cz-embed')) {
              if (!node.title) node.title = titleText;
            }
            if (node.querySelectorAll) setTitles(node);
          } catch (e) {
            // defensive: some nodes may throw on matches/querySelectorAll
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [critizrEnable, reference]);

  if (!critizrEnable) {
    return null;
  }

  return (
    <aside style={{ width: '175px' }} aria-label="Widget d'avis Goodays">
      <a
        className="goodays-widget"
        href={`https://app.goodays.co/widgets/vog-vog/${reference}/`}
        data-type="store_button:fact"
        data-params={`{"on_click":{"type":"cz:open:send_feedback:${reference}"},"cta_text":"Envoyer une remarque"}`}
        aria-label="Envoyer votre avis via Goodays"
        rel="noopener noreferrer"
      >
        Goodays: Envoyer mon avis
      </a>
    </aside>
  );
};
export default GooddaysReviewWidget;
